export default __webpack_public_path__ + "static/media/send_icon.5bc34d45.svg";